export default __webpack_public_path__ + "static/media/acc.ef25dac6.png";